/** @jsx dom */
import {connect} from '@viskan/deku-redux';
import Component from './components';

export default connect(
	({router}) => ({
		router
	})
)(Component);
